import * as types from "../constants/ActionTypes";

let storageFilterStatus = localStorage.getItem("npsFilters")
  ? JSON.parse(localStorage.getItem("npsFilters"))
  : "";

let initialState = {
  active: storageFilterStatus ? storageFilterStatus.active : false,
  business: storageFilterStatus ? storageFilterStatus.business : [],
  period: storageFilterStatus
    ? storageFilterStatus.period
    : [{ id: 5, label: "Personalizar" }],
  comparison: storageFilterStatus
    ? storageFilterStatus.comparison
    : [{ id: "PROMOTOR", label: "Promotor" }],
  units: storageFilterStatus ? storageFilterStatus.units : [],
  datestart: storageFilterStatus
    ? storageFilterStatus.datestart
    : new Date(new Date().setDate(new Date().getDate() - 30)),
  dateend: storageFilterStatus ? storageFilterStatus.dateend : new Date(),
  dateendComparisons:
    storageFilterStatus && storageFilterStatus.dateendComparisons
      ? storageFilterStatus.dateendComparisons
      : new Date(),
  datestartComparisons:
    storageFilterStatus && storageFilterStatus.datestartComparisons
      ? storageFilterStatus.datestartComparisons
      : new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
  questionsNPS:
    storageFilterStatus && storageFilterStatus.questionsNPS
      ? storageFilterStatus.questionsNPS
      : [],
  questionsCSAT:
    storageFilterStatus && storageFilterStatus.questionsCSAT
      ? storageFilterStatus.questionsCSAT
      : [],
  channels:
    storageFilterStatus && storageFilterStatus.channels
      ? storageFilterStatus.channels
      : [],
};

function npsfilters(state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_FILTERS_NPS: {
      let newState = { ...state };
      newState[action.to] = action.value;
      return newState;
    }
    // case types.DELETE_DASH:
    //     return initialState;
    default:
      return state;
  }
}

export default npsfilters;
